import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SERVER_API_URL } from '../../app.constants';

@Injectable({ providedIn: 'root' })
export class PckeAuthorizationService  {
    constructor(private http: HttpClient) { }

    /**
     * Submits the PKCE authorization approval request to the server and, on success,
     * redirects the browser to the client's redirect_uri with the freshly issued
     * authorization code — completing the silent re-authentication flow.
     */
    async doAuthorizeSubmit(approveRequest: ApproveRequest) {

        const approveResponse = await this.approve(approveRequest).toPromise();

        if (approveResponse) {
            // Only redirect if the client_id and redirect_uri were provided, confirming
            // this is a valid OAuth/PKCE authorization request.
            if (approveRequest.clientId && approveRequest.redirectUri) {
                window.location.href = `${approveRequest.redirectUri}?code=${approveResponse.code}&state=${approveRequest.state}`;
            }
        }
        return false;
    }

    /**
     * Calls the server-side OAuth approve endpoint to exchange the PKCE authorization
     * request details (client_id, redirect_uri, code_challenge, etc.) for a fresh
     * authorization code
     */
    private approve(request: ApproveRequest): Observable<ApproveResponse> {
        let params = new HttpParams()
            .set('client_id', request.clientId)
            .set('redirect_uri', request.redirectUri)
            .set('code_challenge', request.codeChallenge)
            .set('code_challenge_method', request.codeChallengeMethod);

        if (request.scope) {
            params = params.set('scope', request.scope);
        }
        if (request.state) {
            params = params.set('state', request.state);
        }

        return this.http.post<ApproveResponse>(
            `${SERVER_API_URL}oauth/approve`, null,
            {
                params
            }
        );
    }
}

export interface ApproveRequest {
    clientId: string;
    redirectUri: string;
    codeChallenge: string;
    codeChallengeMethod: string;
    scope?: string;
    state?: string;
}

export interface ApproveResponse {
    code: string;
    state: string;
}
